import { useQuery } from '@tanstack/react-query';
import { GetRolePermissionsResponseSchema, type GetRolePermissionsResponse } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useRolePermissions(id: string) {
  const client = useApiClient();
  return useQuery<GetRolePermissionsResponse>({
    queryKey: ['role', id, 'permissions'],
    queryFn: ({ signal }) =>
      client.get<GetRolePermissionsResponse>(
        `/roles/${id}/permissions`,
        { signal },
        GetRolePermissionsResponseSchema,
      ),
    enabled: !!id,
  });
}
